export function buildShareUrl(seconds: number, baseHref?: string): string {
  const href = baseHref || (typeof window !== 'undefined' ? window.location.href : '')
  try {
    const url = new URL(href, typeof window !== 'undefined' ? window.location.origin : 'http://localhost')
    url.searchParams.set('t', String(Math.max(0, Math.floor(seconds))))
    url.hash = ''
    return url.toString()
  } catch {
    const t = Math.max(0, Math.floor(seconds))
    const clean = href.split('#')[0]
    const join = clean.includes('?') ? '&' : '?'
    return `${clean.replace(/([?&])t=\d+/g, '').replace(/[?&]$/, '')}${join}t=${t}`
  }
}

export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    /* fall through */
  }
  try {
    const ta = document.createElement('textarea')
    ta.value = text
    ta.style.cssText = 'position:fixed;left:-9999px;top:0'
    document.body.appendChild(ta)
    ta.select()
    const ok = document.execCommand('copy')
    ta.remove()
    return ok
  } catch {
    return false
  }
}
